import { render, staticRenderFns } from "./aviso.vue?vue&type=template&id=0c9068f5&"
import script from "./aviso.vue?vue&type=script&lang=js&"
export * from "./aviso.vue?vue&type=script&lang=js&"
import style0 from "./aviso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports